import React from "react";
import {
  Box,
  Container,
  Typography,
} from "@mui/material";

import Promotions2 from "./Promotion2";

const AboutUs = () => {
  return (
    <Box
      component="main"
      dir="rtl"
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        overflowX: "hidden",
        boxSizing: "border-box",

        py: {
          xs: 2,
          sm: 3,
          md: 5,
        },
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",

          px: {
            xs: 2,
            sm: 3,
            md: 4,
          },
        }}
      >
        <Typography
          component="h1"
          sx={{
            color: "#D81B60",
            fontWeight: 800,
            textAlign: "right",

            fontSize: {
              xs: "1.75rem",
              sm: "2.25rem",
              md: "3rem",
            },

            lineHeight: 1.25,

            mb: {
              xs: 2,
              sm: 3,
            },
          }}
        >
          קצת עלינו
        </Typography>

        <Typography
          component="p"
          sx={{
            width: "100%",
            maxWidth: {
              xs: "100%",
              md: 900,
            },

            color: "#37474f",
            fontWeight: 500,
            textAlign: "right",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",

            fontSize: {
              xs: "1rem",
              sm: "1.15rem",
              md: "1.3rem",
            },

            lineHeight: {
              xs: 1.8,
              sm: 1.9,
            },

            mb: {
              xs: 3,
              sm: 4,
            },
          }}
        >
          שיינ׳ס סטוק נפתחה בתשפ"ב כשהיא
          מומחית לחומרי יצירה וכלי כתיבה
          ממגוון סוגים וחברות. אצלנו המוטו
          הוא שירות אישי ומקצועי ללקוחותינו.
          נשמח לענות לכל פנייה ושאלה.
        </Typography>

        <Box
          component="section"
          aria-label="המבצעים שלנו"
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            overflowX: "hidden",
            boxSizing: "border-box",

            /*
             * מונע מהקרוסלה שבתוך
             * Promotions2 לחרוג מרוחב הטלפון.
             */
            "& .carousel-root": {
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
            },

            "& .carousel": {
              width: "100%",
              maxWidth: "100%",
            },

            "& .carousel-slider": {
              width: "100%",
              maxWidth: "100%",
            },

            "& .slider-wrapper": {
              width: "100%",
              maxWidth: "100%",
            },

            "& img": {
              display: "block",
              width: "100%",
              maxWidth: "100%",
              height: "auto",
              objectFit: "contain",
            },
          }}
        >
          <Promotions2 />
        </Box>
      </Container>
    </Box>
  );
};

export default AboutUs;